import React, { useState, useEffect } from 'react';
import "./ProfileInfo.css";
import CakeIcon from "@material-ui/icons/Cake";
import PinDropRoundedIcon from "@material-ui/icons/PinDropRounded";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import { db } from "../firebase";
import LatestNewsPost from "../components/LatestNewsPost";
import firebase from "firebase";

function ProfileInfo({ username, uid }) {
    const [profileUser, setProfileUser] = useState();
    const [latestNews, setLatestNews] = useState([]);
    const user = firebase.auth().currentUser;

    useEffect(() => {
        db.collection("userInfo").onSnapshot((snapshot) => {
            // eslint-disable-next-line
            snapshot.docs.map((doc) => {
                if(doc.data().uid === uid) {
                    setProfileUser(doc.data())
                }
            })
        })
    }, [uid])

    useEffect(() => {
        db.collection("latestNews").orderBy("timestamp", "desc").onSnapshot((snapshot) => {
            setLatestNews(snapshot.docs.map(doc => ({
                id: doc.id,
                LN: doc.data()
            })))
        })
    }, [])

    return (
        <div className="profileInfo">
            <div className="profileInfo__cards">
                <div className="side__header">
                    <h2>Birthday and location</h2>
                </div>
                <div className="birthdayandlocation">
                    {
                        profileUser?.dob && (
                            <><CakeIcon style={{ color: "deeppink" }} /><span>{`${profileUser?.dob}`}</span></>
                        )
                    }
                </div>
                <div className="birthdayandlocation">
                    {
                        profileUser?.location && (
                            <><PinDropRoundedIcon style={{ color: "blue" }} /><span>{`${profileUser?.location}`}</span></>
                        )
                    }
                </div>
            </div>
            
            <div className="profileInfo__cards">
                <div className="side__header">
                    <h2>Contact</h2>
                </div>
                <div className="contactInfo">
                    {
                        profileUser?.email && (
                            <><ContactMailIcon style={{ color: "violet" }} /><span>{`${profileUser?.email}`}</span></>
                        )
                    }
                </div>
            </div>
            <div className="profileOwnersLN">
                <div className="LN__header">
                        <h2>Latest News</h2>
                        <p>{`from ${profileUser?.displayName}`}</p>
                </div>
                <div className="LN__posts">
                    {
                        latestNews.map(({id, LN}) => (
                            LN.uid !== uid ? (
                                console.log()
                            ) : (
                                <LatestNewsPost key={id} LNId={id} user={user} username={LN.username} imageUrl={LN.imageUrl} photoURL={LN.photoURL} caption={LN.caption} />
                            )
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default ProfileInfo;